// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"common","945":"dashboard"}[chunkId] || chunkId) + "-legacy." + {"76":"c3d35708","141":"d14fb338","945":"d58354f9","959":"3584e91a"}[chunkId] + ".js";
};